<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" @click=Done>
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td style="width:40%; padding-left: 20px;">
                      </td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Campaign Type</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.campaigntype }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Start Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.campaignstartdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">End Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.campaignenddate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                  </table>
                  <div style="margin-top: 5px; margin-bottom: 5px;"></div>
                  <table style="width: 100%">
                    <tr>
                      <td><div align="center"><h3 class="ma-0"><b>{{ initvalue.campaignname}}</b></h3></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                    <div v-for="(trans) in details"  v-bind:key="trans._id" style="padding-bottom: 20px;">
                      <span v-html="trans.detailbody" style="line-height: 1;"></span>
                      <!-- <span v-if="trans.detailimage!=null && trans.detailimage!=''"><img :src="trans.detailimage" style="max-width: 600px; max-height: 300px; object-fit: contain;" /></span> -->
                    </div>
                  </v-col>
                </v-row>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo, formatHtmlText } from '../../../util/tools';

    export default {
        name: 'PrintPage',
        data(){
          return {
            paymethod: null,
            qrsize: 100,
            initvalue: {},
            details: [],
            logo: null,
            isTrade: false,
            companysettings: null,
            currencysettings: null,
            taxsettings: null,
          };
        },
        methods: {
          ...mapActions('Location', ['getLocationsRequest']),
          ...mapActions('Region', ['getRegionsRequest']),
          ...mapActions('SystemSetting', ['getSystemSettingsRequest']),
          ...mapActions('Township', ['getTownshipsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          Done() {
            if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
            else this.$router.replace({ name: 'Dashboard' });
          },
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          getBody(body){
              let result = body.replaceAll("<p>", "<p style='font-size: 14pt;'>");
                console.log(result);
             return result;
          },
          convertCurrency(amount){
            let rate = parseFloat(this.initvalue.currencyRate);
            console.log("rate", rate);
            if(rate==null) rate = 0;
            return amount * rate;
          },
          getCompanySetting(name){
            if(!this.companysettings) return '';
            let result = this.companysettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
          getCurrencySetting(name){
            if(!this.currencysettings) return '';
            let result = this.currencysettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
          getTaxSetting(name){
            if(!this.taxsettings) return '';
            let result = this.taxsettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
        },
        computed: {
          ...mapState('Location', ['locations']),
          ...mapState('Region', ['regions']),
          ...mapState('PayMethod', ['paymethods']),
          ...mapState('SystemSetting', ['settings']),
          ...mapState('Township', ['townships']),
          ...mapState('User', ['users']),
        },
        async created () {
          this.initvalue = this.$route.params;
          this.details = Object.assign([], this.initvalue.details);
          this.details.sort((a,b) =>{
            if (b.detailrank > a.detailrank) return -1;
            if (a.detailrank < b.detailrank) return 1;
            return 0;
          });
          for(var i in this.details){
            var detail = this.details[i];
            detail.detailbody = formatHtmlText(detail.detailbody);
          }
          var companyid = localStorage.getItem("companyid");
          this.logo = getLogo(companyid);
          
          
          if(!this.initvalue._id) this.$router.push({ name: 'MarketProjectList' });
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.regions.length==0) await this.getRegionsRequest();
          if(this.settings.length==0) await this.getSystemSettingsRequest();

          this.taxsettings = this.settings.find(setting=>setting.settingcode=='TaxSettings');
          this.companysettings = this.settings.find(setting=>setting.settingcode=='CompanySettings'); 
          this.currencysettings = this.settings.find(setting=>setting.settingcode=='CurrencySettings');  
        },
        mounted(){

        }
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
